import { c as _c } from "react/compiler-runtime";
import { FilterList, NavArrowDown } from '@byway/icons';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { type Key, Button as RAC_Button } from 'react-aria-components';
import { AriaSelect, SelectItem } from '~/components/AriaSelect';
import { type Sort, useBlueprintIndexStore, useSortedBlueprints } from '~/stores/blueprintIndexStore';
import { trackEvent } from '~/utils';
import { kebabToSnake } from '~/utils/datoHelpers';
import { FiltersDrawer, FiltersPanel } from '../FiltersDrawer/FiltersDrawer';
import styles from './BlueprintIndexControls.module.css';
export function BlueprintIndexControls() {
  const $ = _c(70);
  const t = useTranslations();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const {
    sort,
    setSort
  } = useBlueprintIndexStore(_temp);
  const sortedBlueprints = useSortedBlueprints();
  let t0;
  if ($[0] !== t) {
    t0 = t("content.blueprintIndex.sort_duration_desc");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = {
      name: t0,
      id: "duration-desc"
    };
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("content.blueprintIndex.sort_duration_asc");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = {
      name: t2,
      id: "duration-asc"
    };
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t) {
    t4 = t("content.blueprintIndex.sort_price_desc");
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t4) {
    t5 = {
      name: t4,
      id: "price-desc"
    };
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("content.blueprintIndex.sort_price_asc");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t6) {
    t7 = {
      name: t6,
      id: "price-asc"
    };
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t) {
    t8 = t("content.blueprintIndex.sort_price_per_night_desc");
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t8) {
    t9 = {
      name: t8,
      id: "price-per-night-desc"
    };
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t) {
    t10 = t("content.blueprintIndex.sort_price_per_night_asc");
    $[20] = t;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10) {
    t11 = {
      name: t10,
      id: "price-per-night-asc"
    };
    $[22] = t10;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t1 || $[25] !== t11 || $[26] !== t3 || $[27] !== t5 || $[28] !== t7 || $[29] !== t9) {
    t12 = [t1, t3, t5, t7, t9, t11];
    $[24] = t1;
    $[25] = t11;
    $[26] = t3;
    $[27] = t5;
    $[28] = t7;
    $[29] = t9;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  const selectItems = t12 as const;
  const t13 = `${sortedBlueprints.length}`;
  let t14;
  if ($[31] !== t13) {
    t14 = <strong>{t13}</strong>;
    $[31] = t13;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t) {
    t15 = t("content.blueprintIndex.trips_found");
    $[33] = t;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t15) {
    t16 = <span>{t15}</span>;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t14 || $[38] !== t16) {
    t17 = <p className={styles.results}>{t14} {t16}</p>;
    $[37] = t14;
    $[38] = t16;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = () => setDrawerOpen(false);
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== drawerOpen || $[42] !== sortedBlueprints.length) {
    t19 = <FiltersDrawer isOpen={drawerOpen} close={t18} blueprintCount={sortedBlueprints.length} />;
    $[41] = drawerOpen;
    $[42] = sortedBlueprints.length;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[44] !== t) {
    t20 = t("aria.sort_by");
    $[44] = t;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  const t21 = `bpi-sort-${sort}`;
  let t22;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <NavArrowDown decorative={true} />;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  let t23;
  if ($[47] !== selectItems || $[48] !== setSort) {
    t23 = selected => {
      const label = selectItems.find(el => el.id === selected)?.name;
      trackEvent("bpi_sort_selected", {
        event_category: "bpi",
        event_label: label ?? "unknown",
        value: kebabToSnake(selected)
      });
      setSort(selected);
    };
    $[47] = selectItems;
    $[48] = setSort;
    $[49] = t23;
  } else {
    t23 = $[49];
  }
  let t24;
  if ($[50] !== selectItems || $[51] !== sort || $[52] !== t20 || $[53] !== t21 || $[54] !== t23) {
    t24 = <AriaSelect displaySelectValue={false} ariaLabel={t20} data-ua-click={t21} icon={t22} key={sort} onSelectionChange={t23} selectedKey={sort} items={selectItems}>{_temp2}</AriaSelect>;
    $[50] = selectItems;
    $[51] = sort;
    $[52] = t20;
    $[53] = t21;
    $[54] = t23;
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  let t25;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = () => setDrawerOpen(true);
    $[56] = t25;
  } else {
    t25 = $[56];
  }
  let t26;
  if ($[57] !== t) {
    t26 = t("content.blueprintIndex.filters_button");
    $[57] = t;
    $[58] = t26;
  } else {
    t26 = $[58];
  }
  let t27;
  if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <FilterList decorative={true} strokeWidth={2} />;
    $[59] = t27;
  } else {
    t27 = $[59];
  }
  let t28;
  if ($[60] !== t26) {
    t28 = <RAC_Button className={styles.filterButton} onPress={t25}>{t26}{t27}</RAC_Button>;
    $[60] = t26;
    $[61] = t28;
  } else {
    t28 = $[61];
  }
  let t29;
  if ($[62] !== t24 || $[63] !== t28) {
    t29 = <div className={styles.buttons}>{t24}{t28}</div>;
    $[62] = t24;
    $[63] = t28;
    $[64] = t29;
  } else {
    t29 = $[64];
  }
  let t30;
  if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <FiltersPanel />;
    $[65] = t30;
  } else {
    t30 = $[65];
  }
  let t31;
  if ($[66] !== t17 || $[67] !== t19 || $[68] !== t29) {
    t31 = <div className={styles.controlsContainer}>{t17}{t19}{t29}{t30}</div>;
    $[66] = t17;
    $[67] = t19;
    $[68] = t29;
    $[69] = t31;
  } else {
    t31 = $[69];
  }
  return t31;
}
function _temp2(item) {
  return <SelectItem key={item.id}>{item.name}</SelectItem>;
}
function _temp(state) {
  return state;
}